import { Component } from '@theme/component';

/**
 * FlyToCart custom element.
 * CSS variables (--start-x, --start-y, --travel-x, --travel-y) are set by the
 * caller on the element BEFORE appendChild so animations start correctly on the
 * first frame. This component only handles cleanup after the animation finishes.
 */
class FlyToCart extends Component {
  /** @type {Element} */
  source;

  /** @type {boolean} */
  useSourceSize = false;

  /** @type {Element} */
  destination;

  connectedCallback() {
    super.connectedCallback();

    requestAnimationFrame(() => {
      Promise.allSettled(this.getAnimations().map((a) => a.finished)).then(() => {
        this.remove();
      });
    });
  }
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}
